import React from "react";
import { pure } from "recompose";
import { getRateDecimalsNoRounding } from "../../utils/misc";
import classnames from "classnames";
import "./Amount.scss";
const calculateFontStyles = (value) => {
    if (!value) {
        return null;
    }
    const valueString = Math.floor(value).toString();
    if (valueString.length > 7) {
        return "fontSmaller";
    }
    if (valueString.length > 5) {
        return "fontSmall";
    }
    return null;
};
function Amount({ amount, integerClassName, decimalClassName, className }) {
    const formattedNumber = amount.toFixed(2);
    return (<div className={classnames("wbkv9-Amount", "Amount", className, calculateFontStyles(amount))}>
      <div className={classnames("wbkv9-Amount-integerPart", "integerPart", integerClassName)}>
        {parseInt(formattedNumber, 10)}
      </div>
      <div className={classnames("wbkv9-Amount-decimalPart", "decimalPart", decimalClassName)}>
        {getRateDecimalsNoRounding(formattedNumber)}
      </div>
    </div>);
}
Amount.defaultProps = {
    integerClassName: "",
    decimalClassName: "",
    className: "",
};
export default pure(Amount);
